import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-field-intervention-details',
    templateUrl: './field-intervention-details.component.html',
})
export class FieldInterventionDetailsComponent {
    public readonly description = input.required<string>();
    public readonly isFlexRow = input<boolean>(false);
    public readonly scheduledEndDate = input<Date | null>(null);
}
